import * as React from 'react';
import {faClockFour} from '@fortawesome/pro-regular-svg-icons';
import {faCommentDots, faFax, faHouse, faPhoneSquareAlt} from '@fortawesome/pro-solid-svg-icons';
import {faFacebookSquare, faLinkedin, faTwitterSquare, faYoutubeSquare} from '@fortawesome/free-brands-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import Button from '../../ui/Buttons/Button';
import {showChatWindow} from '../contact.functions';

export interface ContactImperialProps {
    horizontal: boolean;
}

export const ContactImperial = ({horizontal}: ContactImperialProps) => {
    const colSize = horizontal ? `tw-grid-cols-1 md:tw-grid-cols-3` : `tw-grid-cols-1`;

    /**
     * Template
     */
    return (
        <div className="tw-bg-gray-100 tw-p-4">
            <div className={`tw-grid ${colSize} -tw-mx-2.5`}>
                <div className={`tw-relative tw-w-full tw-px-2.5 tw-my-4`}>
                    <FontAwesomeIcon
                        className="tw-inline-block tw-mr-2 tw-float-left"
                        icon={faClockFour}
                        size="2x"
                    />
                    <h4 className="tw-block tw-overflow-hidden">
                        Hours
                        <p className="tw-text-base tw-mb-0.5 tw-font-normal tw-my-2 tw-mt-0">
                            Monday-Friday
                            <br />6 AM to 6 PM CST
                        </p>
                    </h4>
                </div>
                <div className={`tw-relative tw-w-full tw-px-2.5 tw-my-4`}>
                    <FontAwesomeIcon
                        className="tw-inline-block tw-mr-2 tw-float-left"
                        icon={faPhoneSquareAlt}
                        size="2x"
                    />
                    <h4 className="tw-block tw-overflow-hidden">
                        Phone Number
                        <p className="tw-text-base tw-mb-0.5 tw-font-normal tw-my-2 tw-mt-0">1-800-558-2808</p>
                    </h4>
                </div>
                <div className={`tw-relative tw-w-full tw-px-2.5 tw-my-4`}>
                    <FontAwesomeIcon
                        className="tw-inline-block tw-mr-2 tw-float-left"
                        icon={faCommentDots}
                        size="2x"
                    />
                    <h4 className="tw-block tw-overflow-hidden">
                        Chat
                        <p className="tw-text-base tw-mb-0.5 tw-font-normal tw-my-2 tw-mt-0">
                            <Button
                                onClick={showChatWindow}
                                size="sm"
                                variant="link"
                            >
                                Start chat now
                            </Button>
                        </p>
                    </h4>
                </div>
                <div className={`tw-relative tw-w-full tw-px-2.5 tw-my-4`}>
                    <FontAwesomeIcon
                        className="tw-inline-block tw-mr-2 tw-float-left"
                        icon={faFax}
                        size="2x"
                    />
                    <h4 className="tw-block tw-overflow-hidden">
                        Fax Number
                        <p className="tw-text-base tw-mb-0.5 tw-font-normal tw-my-2 tw-mt-0">1-800-553-8769</p>
                    </h4>
                </div>
                <div className={`tw-relative tw-w-full tw-px-2.5 tw-my-4`}>
                    <FontAwesomeIcon
                        className="tw-inline-block tw-mr-2 tw-float-left"
                        icon={faHouse}
                        size="2x"
                    />
                    <h4 className="tw-block tw-overflow-hidden">
                        Mailing Addresses
                        <p className="tw-text-xl tw-font-normal tw-mb-0 tw-mt-2">Corporate</p>
                        <p className="tw-text-base tw-font-normal tw-my-2 tw-mt-0 tw-mb-4">
                            Imperial Supplies LLC
                            <br />
                            300 North Madison Street
                            <br />
                            PO Box 11008
                            <br />
                            Green Bay, WI 54307-1008
                        </p>
                        <p className="tw-text-xl tw-font-normal tw-mb-0">Remittance</p>
                        <p className="tw-text-base tw-mb-0.5 tw-font-normal tw-my-2 tw-mt-0">
                            Imperial Supplies LLC
                            <br />
                            PO Box 5362
                            <br />
                            Janesville, WI 53547-5362
                        </p>
                    </h4>
                </div>
                <div className={`tw-relative tw-w-full tw-my-4 tw-px-10`}>
                    <h4>
                        Connect with us.
                        <p className="tw-text-base tw-mb-0.5 tw-font-normal tw-mt-0">
                            <a
                                href="/content/careers"
                                style={{color: `#00599c`}}
                                target="_blank"
                            >
                                Imperial Careers Page
                            </a>
                        </p>
                    </h4>
                    <a
                        className="tw-no-underline"
                        href="https://www.facebook.com/pages/Imperial-Supplies/160873310666103"
                        target="_blank"
                    >
                        <FontAwesomeIcon
                            className="tw-text-gray-900 tw-mr-2"
                            icon={faFacebookSquare}
                            size="4x"
                        />
                    </a>
                    <a
                        className="tw-no-underline"
                        href="https://twitter.com/#!/Imperial_Tweets"
                        target="_blank"
                    >
                        <FontAwesomeIcon
                            className="tw-text-gray-900 tw-mr-2"
                            icon={faTwitterSquare}
                            size="4x"
                        />
                    </a>
                    <a
                        className="tw-no-underline"
                        href="https://www.youtube.com/user/ImperialSupplies"
                        target="_blank"
                    >
                        <FontAwesomeIcon
                            className="tw-text-gray-900 tw-mr-2"
                            icon={faYoutubeSquare}
                            size="4x"
                        />
                    </a>
                    <a
                        className="tw-no-underline"
                        href="https://www.linkedin.com/company/imperial-supplies"
                        target="_blank"
                    >
                        <FontAwesomeIcon
                            className="tw-text-gray-900"
                            icon={faLinkedin}
                            size="4x"
                        />
                    </a>
                </div>
            </div>
        </div>
    );
};
